"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigKey = void 0;
var ConfigKey;
(function (ConfigKey) {
    ConfigKey["INITIALIZE_LEVEL"] = "initializeLevel";
    ConfigKey["ADMIN_TENANT_ID"] = "adminTenantId";
    ConfigKey["SERVER_FQDN"] = "serverFqdn";
    ConfigKey["BOX_DEFAULT_CREDENTIAL"] = "boxDefaultCredential";
    ConfigKey["AWS_DEFAULT_CLIENT_ID"] = "awsDefaultClientId";
    ConfigKey["AWS_DEFAULT_CLIENT_SECRET"] = "awsDefaultClientSecret";
    ConfigKey["AWS_DEFAULT_ROLE"] = "awsDefaultRole";
    ConfigKey["CONCUR_CLIENT_ID"] = "concurClientId";
    ConfigKey["CONCUR_CLIENT_SECRET"] = "concurClientSecret";
    ConfigKey["CONCUR_PDF_CONTENT_TYPE"] = "concurPdfContentType";
    ConfigKey["CONCUR_APP_CENTER_URL"] = "concurAppCenterUrl";
    ConfigKey["SUPPLIER_CACHE_DURATION"] = "supplierCacheDuration";
    ConfigKey["COUPA_CLIENT_ID"] = "coupaClientId";
    ConfigKey["COUPA_CLIENT_SECRET"] = "coupaClientSecret";
    ConfigKey["OBC_SERVER_HOST"] = "obcServerHost";
    ConfigKey["OBC_CLIENT_ID"] = "obcClientId";
    ConfigKey["OBC_CLIENT_SECRET"] = "obcClientSecret";
    ConfigKey["OBC_SUBSCRIPTION_KEY_PRIMARY"] = "obcSubscriptionKeyPrimary";
    ConfigKey["OBC_SUBSCRIPTION_KEY_SECONDARY"] = "obcSubscriptionKeySecondary";
    ConfigKey["OBC_LOGIN_URL"] = "obcLoginUrl";
    ConfigKey["OBC_CALLBACK_URL"] = "obcCallbackUrl";
    ConfigKey["INFOMART_IS_TEST"] = "infomartIsTest";
    ConfigKey["INFOMART_CLIENT_ID"] = "infomartClientId";
    ConfigKey["INFOMART_CLIENT_SECRET"] = "infomartClientSecret";
    ConfigKey["AWS_COMMON_CLIENT_ID"] = "awsCommonClientId";
    ConfigKey["AWS_COMMON_CLIENT_SECRET"] = "awsCommonClientSecret";
    ConfigKey["AWS_COMMON_SES_ENDPOINT"] = "awsCommonSesEndpoint";
    ConfigKey["AWS_COMMON_SES_REGION"] = "awsCommonSesRegion";
    ConfigKey["AWS_COMMON_S3_REGION"] = "awsCommonS3Region";
    ConfigKey["AWS_COMMON_S3_BUCKET"] = "awsCommonS3Bucket";
    ConfigKey["SYSTEM_ERROR_SLACK_WEBHOOK_URL"] = "systemErrorSlackWebhookUrl";
    ConfigKey["TESTER_WEB_SLACK_NOTIFY_CHANNEL"] = "testerWebSlackNotifyChannel";
    ConfigKey["TESTER_WEB_SLACK_TOKEN"] = "testerWebSlackToken";
    ConfigKey["DEFAULT_JOB_EMAIL_DOMAIN"] = "defaultJobEmailDomain";
    ConfigKey["DEFAULT_JOB_EMAIL_SES_REGION"] = "defaultJobEmailSesRegion";
    ConfigKey["DEFAULT_JOB_EMAIL_SES_RULE_SET"] = "defaultJobEmailSesRuleSet";
    ConfigKey["DEFAULT_JOB_EMAIL_SES_BUCKET"] = "defaultJobEmailSesBucket";
    ConfigKey["DEFAULT_JOB_EMAIL_SES_FOLDER"] = "defaultJobEmailSesFolder";
    ConfigKey["DEFAULT_JOB_EMAIL_SES_ARCHIVE_FOLDER"] = "defaultJobEmailSesArchiveFolder";
    ConfigKey["DEFAULT_JOB_EMAIL_SES_ROLE"] = "defaultJobEmailSesRole";
    ConfigKey["DEFAULT_JOB_EMAIL_SES_LAMBDA_ARN"] = "defaultJobEmailSesLambdaArn";
    ConfigKey["REMOTA_DEBUG_SECRET"] = "remotaDebugSecret";
    ConfigKey["ACCOUNTING_SYNC_SOURCE"] = "accountingSyncSource";
})(ConfigKey = exports.ConfigKey || (exports.ConfigKey = {}));
